import type { SupportedCountries } from '@wanda-space/types'

export function getFlagEmoji(countryCode: SupportedCountries | 'NO' | 'SE') {
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map((char) => 127397 + char.charCodeAt(0))
  return String.fromCodePoint(...codePoints)
}
